import * as types from "./viewManagerTypes";


export const fetchManagersRequest = () => ({
    type: types.FETCH_MANAGER_REQUEST,
  });
  
  export const fetchManagersSuccess = (managers) => ({
    type: types.FETCH_MANAGER_SUCCESS,
    payload: managers,
  });
  
  export const fetchManagersFailure = (error) => ({
    type: types.FETCH_MANAGER_FAILURE,
    payload: error,
  });